/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

import { gsap } from "gsap";
    
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { TextPlugin } from "gsap/TextPlugin";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger) 
gsap.registerPlugin(ScrambleTextPlugin,TextPlugin);

let heroSplit    = SplitText.create("#hero hgroup h1", { type: "lines" });

let bigAnimation = 30;
let smallAnimation = 15;

async function loadAnimations() 
{
    for(i = 0; i < heroSplit.lines.length; i++)
    {
        let split2 = SplitText.create(heroSplit.lines[i], { type: "chars" });
        // now animate the characters in a staggered fashion
        gsap.from(split2.chars, {
          duration: 0.5, 
          y: bigAnimation,
          x: bigAnimation,
          autoAlpha: 0,
          stagger: 0.06,
          delay: 1.25 * i,
          textShadow: '10px 10px var(--codentia-coral)'
        });
    }

    gsap.from("#hero hgroup > p", {
        opacity: 0, 
        y: smallAnimation,
        duration: 0.5,
        delay: 3,
        x: smallAnimation,
    });

    gsap.from("#hero .icon-button", {
        opacity: 0, 
        y: smallAnimation,
        x: smallAnimation,
        duration: 0.5,
        delay: 3.5
    });

    gsap.from("#services hgroup > *", {
        scrollTrigger: {
            trigger: '#services',
            start: 'top 80%'
        },
        opacity: 0, 
        y: smallAnimation,
        x: -smallAnimation,
        duration: 0.5,
        delay: 0.5,
        stagger: 0.5
    });

    gsap.from("#services ul li", {
        scrollTrigger: {
            trigger: '#services',
            start: 'top 80%'
        },
        opacity: 0, 
        y: smallAnimation,
        x: -smallAnimation,
        duration: 0.5,
        delay: 1.5,
        stagger: 0.2
    });

    gsap.from("#team hgroup > *", {
        scrollTrigger: {
            trigger: '#team',
            start: 'top 80%'
        },
        opacity: 0, 
        y: smallAnimation,
        x: smallAnimation,
        duration: 0.5,
        delay: 0.5,
        stagger: 0.5
    });

    gsap.from("#team ul li", {
        scrollTrigger: {
            trigger: '#team',
            start: 'top 80%'
        },
        opacity: 0, 
        y: smallAnimation,
        x: smallAnimation,
        duration: 0.5,
        delay: 1.5,
        stagger: 0.2
    });
    
}

loadAnimations();

window.openDialog = () =>
{
    document.getElementById('contact').showModal()
    gsap.to('#contact', {
          duration: 0.25, 
          y: 0,
          x: 0,
          autoAlpha: 1,
    })
}

window.closeDialog = () =>
{
    gsap.to('#contact', {
          duration: 0.25, 
          y: smallAnimation,
          x: 0,
          autoAlpha: 0,
    }).then(() => document.getElementById('contact').close())
    
}